import { useMemo } from 'react';

import { PageViewedTracker } from '@zenbusiness/application-commons-clickstream';
import { useLocation } from 'react-router-dom';

import useAstraProfileContext from '#client/hooks/useAstraProfileContext';

const RudderStackEvent = () => {
  const { pathname } = useLocation();
  const { isHideInstantDepositOption } = useAstraProfileContext();

  const properties = useMemo(
    () =>
      isHideInstantDepositOption
        ? {
            customDestinationPageName_: 'banking_account_notfunded_dashboard',
            appPageName: 'banking_account_not_funded_dashboard',
            appSection: 'banking',
            experienceOrigin: 'dashboard'
          }
        : {
            customDestinationPageName_: 'banking_account_not_funded_dashboard_with_astra',
            appPageName: 'banking_account_notfunded_dashboard_with_astra',
            appSection: 'banking',
            experienceOrigin: 'dashboard'
          },
    [isHideInstantDepositOption]
  );

  return (
    <PageViewedTracker
      {...properties}
      key={pathname}
    />
  );
};

export default RudderStackEvent;
